import {
  asStableCallback,
  useStableCallback,
} from "@bezoned/shared/hooks/use-stable-callback.js";
import type { ChannelTabListResponse } from "@bezoned/shared/types/api/channel/channel-tab-list.types.js";
import { useState } from "react";

import { ContextMenuContent } from "../../../features/context-menu/context-menu-content.jsx";
import { useTeamsNavigation } from "../../../hooks/use-teams-navigation.js";
import { AddNewBoardInstructions } from "../add-new-board-instructions.jsx";

interface MeetingSidePanelProps {
  displayName: string | null;
  channelUuid: string;
  msChannelId: string | null;
  tabs: ChannelTabListResponse["tabs"];
}

export const MeetingSidePanel = ({
  displayName,
  channelUuid,
  msChannelId,
  tabs,
}: MeetingSidePanelProps) => {
  const [showAddNewBoardInstructions, setShowAddNewBoardInstructions] =
    useState(false);
  const { navigateToChannel } = useTeamsNavigation({
    onCompleted: () => {
      setShowAddNewBoardInstructions(false);
    },
  });

  const handleAddNewBoardNext = () => {
    if (msChannelId) {
      navigateToChannel(msChannelId, displayName ?? "conversations");
    }
  };
  const handleNavigationCompleted56 = useStableCallback(() => {});

  const handleAddNewBoard52 = useStableCallback(() => {
    setShowAddNewBoardInstructions(true);
  });

  // Display the instructions in-line instead of using the modal renderer
  if (showAddNewBoardInstructions) {
    return (
      <AddNewBoardInstructions
        onClose={asStableCallback(() => {
          setShowAddNewBoardInstructions(false);
        })}
        onNext={handleAddNewBoardNext}
      />
    );
  }

  return (
    <ContextMenuContent
      channelUuid={channelUuid}
      displayName={displayName}
      loading={false}
      msChannelId={msChannelId}
      onAddNewBoard={handleAddNewBoard52}
      onNavigationCompleted={handleNavigationCompleted56}
      tabs={tabs}
      variant="meeting"
    />
  );
};
